export const departamentosMendoza = {
  capital: {
    name: 'Ciudad de Mendoza',
    description: 'Capital provincial de perfil urbano, cultural y gastronómico, reconocida por sus acequias, arboledas y plazas. Integra servicios, comercio y una conexión directa con el Parque General San Martín.',
    landmarks: ['Parque General San Martín', 'Cerro de la Gloria', 'Área Fundacional', 'Mercado Central'],
    tags: ['urbano', 'cultural', 'gastronómico'],
  },
  godoy_cruz: {
    name: 'Godoy Cruz',
    description: 'Departamento integrado al Gran Mendoza, con áreas residenciales consolidadas, actividad comercial, ciclovías y una agenda cultural activa.',
    landmarks: ['Parque Benegas', 'Espacio Arizu', 'Plaza departamental', 'Corredor del Acceso Sur'],
    tags: ['residencial', 'conectado', 'cultural'],
  },
  guaymallen: {
    name: 'Guaymallén',
    description: 'El departamento más poblado de Mendoza combina barrios residenciales, polos comerciales, producción agrícola y accesos estratégicos al área metropolitana.',
    landmarks: ['Predio de la Virgen', 'Acceso Este', 'Parque Unimev', 'Distritos de Dorrego y San José'],
    tags: ['metropolitano', 'comercial', 'residencial'],
  },
  las_heras: {
    name: 'Las Heras',
    description: 'Extenso departamento que conecta el Gran Mendoza con la alta montaña y reúne áreas urbanas, paisajes cordilleranos y patrimonio histórico.',
    landmarks: ['Parque Provincial Aconcagua', 'Uspallata', 'Puente del Inca', 'Reserva Villavicencio'],
    tags: ['montaña', 'naturaleza', 'metropolitano'],
  },
  lujan_de_cuyo: {
    name: 'Luján de Cuyo',
    description: 'Zona residencial, vitivinícola y turística al sur del Gran Mendoza, con localidades de montaña y una importante oferta gastronómica.',
    landmarks: ['Chacras de Coria', 'Potrerillos', 'Cacheuta', 'Caminos del vino'],
    tags: ['vino', 'montaña', 'residencial'],
  },
  maipu: {
    name: 'Maipú',
    description: 'Departamento histórico de tradición vitivinícola y olivícola, conectado con el área metropolitana y reconocido por sus circuitos productivos.',
    landmarks: ['Museo Nacional del Vino y la Vendimia', 'Bodega Giol', 'Coquimbito', 'Circuitos de vino y olivo'],
    tags: ['vitivinícola', 'histórico', 'residencial'],
  },
  lavalle: {
    name: 'Lavalle',
    description: 'Territorio del norte mendocino de fuerte identidad rural y huarpe, con ambientes de monte y áreas naturales protegidas.',
    landmarks: ['Lagunas de Guanacache', 'Reserva Telteca', 'Costa de Araujo', 'Asunción'],
    tags: ['rural', 'naturaleza', 'cultural'],
  },
  junin: {
    name: 'Junín',
    description: 'Departamento del Este mendocino con producción vitivinícola, localidades tranquilas y espacios recreativos de escala regional.',
    landmarks: ['Parque Recreativo Dueño del Sol', 'Camping El Pinar', 'La Colonia', 'Circuitos productivos'],
    tags: ['productivo', 'familiar', 'tranquilo'],
  },
  san_martin: {
    name: 'General San Martín',
    description: 'Centro urbano y productivo del Este provincial, con fuerte tradición vitivinícola y conexiones hacia los principales corredores regionales.',
    landmarks: ['Museo Histórico Las Bóvedas', 'Palmira', 'Centro de San Martín', 'Ruta del vino del Este'],
    tags: ['vitivinícola', 'urbano', 'conectado'],
  },
  rivadavia: {
    name: 'Rivadavia',
    description: 'Departamento del Este de perfil agrícola y vitivinícola, con vida cultural local y acceso a paisajes recreativos.',
    landmarks: ['Embalse El Carrizal', 'Ciudad de Rivadavia', 'Medrano', 'Los Campamentos'],
    tags: ['productivo', 'recreativo', 'tranquilo'],
  },
  santa_rosa: {
    name: 'Santa Rosa',
    description: 'Departamento del Este mendocino con localidades rurales, producción agropecuaria y uno de los ambientes protegidos más representativos del monte.',
    landmarks: ['Reserva de Biósfera Ñacuñán', 'Las Catitas', 'La Dormida', 'Santa Rosa'],
    tags: ['rural', 'naturaleza', 'productivo'],
  },
  la_paz: {
    name: 'La Paz',
    description: 'Puerta oriental de Mendoza, con identidad rural, patrimonio local y conexión directa con el corredor nacional hacia San Luis.',
    landmarks: ['Desaguadero', 'Villa Antigua', 'Centro de La Paz', 'Arco de ingreso a Mendoza'],
    tags: ['rural', 'histórico', 'conectado'],
  },
  tunuyan: {
    name: 'Tunuyán',
    description: 'Corazón urbano y productivo del Valle de Uco, rodeado de viñedos y paisajes cordilleranos, con servicios para toda la región.',
    landmarks: ['Manzano Histórico', 'Anfiteatro Municipal', 'Vista Flores', 'Caminos del vino'],
    tags: ['valle de uco', 'vino', 'montaña'],
  },
  tupungato: {
    name: 'Tupungato',
    description: 'Departamento del Valle de Uco reconocido por sus viñedos de altura, gastronomía y grandes vistas de la Cordillera de los Andes.',
    landmarks: ['Cristo Rey del Valle', 'Valle de Gualtallary', 'Bodegas de altura', 'Cordón del Plata'],
    tags: ['vino', 'montaña', 'gastronómico'],
  },
  san_carlos: {
    name: 'San Carlos',
    description: 'Departamento del Valle de Uco de perfil agrícola, vitivinícola y natural, con localidades históricas y acceso a áreas cordilleranas.',
    landmarks: ['Reserva Laguna del Diamante', 'Eugenio Bustos', 'La Consulta', 'Pareditas'],
    tags: ['naturaleza', 'vino', 'rural'],
  },
  san_rafael: {
    name: 'San Rafael',
    description: 'Principal centro urbano del sur mendocino, reconocido por su oferta de naturaleza, aventura, producción vitivinícola y servicios regionales.',
    landmarks: ['Cañón del Atuel', 'Valle Grande', 'Los Reyunos', 'Villa 25 de Mayo'],
    tags: ['aventura', 'vino', 'urbano'],
  },
  general_alvear: {
    name: 'General Alvear',
    description: 'Departamento productivo del sur provincial, atravesado por paisajes rurales, oasis irrigados y localidades de identidad propia.',
    landmarks: ['Costanera Alvear', 'Bowen', 'Carmensa', 'Río Atuel'],
    tags: ['productivo', 'rural', 'familiar'],
  },
  malargue: {
    name: 'Malargüe',
    description: 'Extenso territorio del sur mendocino con paisajes volcánicos, nieve, ciencia y algunas de las áreas naturales más singulares de la provincia.',
    landmarks: ['Reserva La Payunia', 'Caverna de las Brujas', 'Las Leñas', 'Observatorio Pierre Auger'],
    tags: ['naturaleza', 'aventura', 'montaña'],
  },
};

export const normalizeTerritory = (value = '') => String(value)
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\b(departamento|municipalidad|ciudad de|general)\b/g, '')
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_|_$/g, '');

export const officialTerritorySource = 'https://www.mendoza.edu.ar/departamentos-de-mendoza/';
